import { ReactNode } from 'react';
import { Surface } from '../../Shared/Components/ui';

interface AuthCardProps {
  logo?: string | null;
  fallbackInitial?: string;
  onLogoError?: () => void;
  children: ReactNode;
}

const logoBox =
  'absolute -top-10 left-1/2 -translate-x-1/2 w-20 h-20 bg-white rounded-2xl shadow-2xl p-3 flex items-center justify-center border border-teal-primary/20';

const AuthCard = ({
  logo,
  fallbackInitial,
  onLogoError,
  children,
}: AuthCardProps) => (
  <Surface
    elevation={2}
    className="w-full max-w-[440px] p-8 tablet:p-12 relative overflow-visible"
  >
    {logo ? (
      <div className={logoBox}>
        <img
          src={logo}
          alt="logo"
          className="w-full h-full object-contain"
          onError={onLogoError}
        />
      </div>
    ) : (
      fallbackInitial && (
        <div
          className={`${logoBox} text-3xl bricolage-grotesque-extrabold text-teal-primary`}
        >
          {fallbackInitial}
        </div>
      )
    )}

    {children}
  </Surface>
);

export default AuthCard;
